export const UPDATE_EMPLOYEE_PREFERENCES_REPORT = 'UPDATE_EMPLOYEE_PREFERENCES_REPORT';
export const RESET_EMPLOYEE_PREFERENCES_REPORT = 'RESET_EMPLOYEE_PREFERENCES_REPORT';
